import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';

/**
 * Screen Orientation Component.
 *
 * @exports
 * @class ScreenOrientationComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-screen-orientation',
  template: ``,
  standalone: true
})
export class ScreenOrientationComponent implements OnInit {
  /**
   * Setup.
   *
   * @memberof ScreenOrientationComponent
   */
  ngOnInit(): void {
    if (Capacitor.isNativePlatform()) this.initialize();
  }

  /**
   * Setup Screen Orientation.
   *
   * @memberof ScreenOrientationComponent
   */
  initialize(): void {
    // lock screen orientation to portrait.
    window.screen.orientation.lock('portrait');
  }
}
